import { VehicleIgnitionStatus } from "../../../common/data/service-proxies";
import Icon from "@mdi/react";
import {
  mdiTruckCheck,
  mdiTruckAlert,
  mdiClipboardCheck,
  mdiClipboardAlert,
  mdiEngine,
  mdiEngineOff,
} from "@mdi/js";
import { makeStyles, Theme, Typography } from "@material-ui/core";

interface Props {
  ignitionStatus?: VehicleIgnitionStatus | null;
  safetyStatus?: boolean;
  healthStatus?: boolean;
}

const useStyles = makeStyles<Theme>((theme) => ({
  success: {
    color: theme.palette.success.main,
  },
  error: {
    color: theme.palette.error.main,
  },
  warning: {
    color: theme.palette.warning.main,
  },
}));

export const VehicleStateHeader = ({
  ignitionStatus,
  safetyStatus,
  healthStatus,
}: Props) => {
  const classes = useStyles();

  return (
    <div className="info-window-content-header col-3">
      <div className="header-info">
        <div>
          <Typography variant="body2">Diag</Typography>
        </div>
        <div>
          {healthStatus ? (
            <Typography variant="body2">
              <Icon path={mdiTruckCheck} size={1} className={classes.success} />
            </Typography>
          ) : (
            <Typography variant="body2">
              <Icon path={mdiTruckAlert} size={1} className={classes.error} />
            </Typography>
          )}
        </div>
      </div>
      <div className="header-info">
        <div>
          <Typography variant="body2">Safety</Typography>
        </div>
        <div>
          {safetyStatus ? (
            <Typography variant="body2">
              <Icon
                path={mdiClipboardCheck}
                size={1}
                className={classes.success}
              />
            </Typography>
          ) : (
            <Typography variant="body2">
              <Icon
                path={mdiClipboardAlert}
                size={1}
                className={classes.error}
              />
            </Typography>
          )}
        </div>
      </div>
      <div className="header-info">
        <div>
          <Typography variant="body2">Engine</Typography>
        </div>
        <div>
          {!ignitionStatus ||
          ignitionStatus === VehicleIgnitionStatus.IgnitionOff ? (
            <Typography variant="body2">
              <Icon path={mdiEngineOff} size={1} className={classes.error} />
            </Typography>
          ) : ignitionStatus === VehicleIgnitionStatus.IgnitionOnDriving ? (
            <Typography variant="body2">
              <Icon path={mdiEngine} size={1} className={classes.success} />
            </Typography>
          ) : (
            <Typography variant="body2">
              <Icon path={mdiEngine} size={1} className={classes.warning} />
            </Typography>
          )}
        </div>
      </div>
    </div>
  );
};
